// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"330":"36f250b701837e63","405":"36f250b701837e63"}[chunkId] + ".css";
};